import { render, staticRenderFns } from "./SkillDetail.vue?vue&type=template&id=6b1c21f5"
import script from "./SkillDetail.vue?vue&type=script&lang=js"
export * from "./SkillDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports